import React, { useEffect, useMemo, useState } from "react";
import { FiSearch, FiEdit2, FiTrash2 } from "react-icons/fi";
import { useLazySearchDoctorQuery } from "../../../State/Api/PharmacySaleApiSlice";

export default function DoctorSelectModal({
  open,
  onClose,
  onCreateNew,
  onEditSelected,
  onDeleteSelected,
  formik,
  doctors = [],
  districts = [],
  initialDistrict = "",
}) {
  const [district, setDistrict] = useState(initialDistrict || "");
  const [query, setQuery] = useState("");
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") { e.preventDefault(); onClose?.(); }
      if (e.key === "F2") { e.preventDefault(); onCreateNew?.(); }
      if (e.key === "F4") { e.preventDefault(); if (selectedId) onEditSelected?.(selectedId); }
      if (e.key === "Delete") { e.preventDefault(); if (selectedId) onDeleteSelected?.(selectedId); }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, selectedId, onClose, onCreateNew, onEditSelected, onDeleteSelected]);

  useEffect(() => {
    if (open) {
      setQuery("");
      setSelectedId(null);
      if (initialDistrict) setDistrict(initialDistrict);
    }
  }, [open, initialDistrict]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return doctors
      .filter(d => (district ? d.district === district : true))
      .filter(d => {
        if (!q) return true;
        const bag = [
          d.name, d.specialization, d.mobile, d.hospital, d.address, String(d.commission || "")
        ].filter(Boolean).join(" ").toLowerCase();
        return bag.includes(q);
      });
  }, [doctors, query, district]);

  const [searchDoctor, { data }] = useLazySearchDoctorQuery();

  useEffect(() => {
    const fetchDoctors = async () => {
      await searchDoctor({ pharmaId: localStorage.getItem("userUniqueID"), doctorName: query });
    }
    if (query && query !== "") {
      fetchDoctors();
    }
  }, [query, searchDoctor]);

  if (!open) return null;

  return (
    <div className="modal fade show d-block app-modal" tabIndex={-1} role="dialog" aria-modal="true">
      <div style={{zIndex:"1060"}} className="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div className="modal-content shadow-lg app-modal-content">
          <div className="modal-header border-0 align-items-start">
            <div>
              <h5 className="modal-title">Select a Doctor</h5>
              <div className="text-muted small">Select an option from the below list</div>
            </div>
            <button className="gradient-button ml-auto" style={{display:"flex", alignItems:"center"}} onClick={onCreateNew}>
              Create New
            </button>
            <button className="ml-1 text-danger" style={{"background":"rgb(254, 226, 226)","border":"none","borderRadius":"6px","width":"36px","height":"36px","cursor":"pointer","display":"flex","alignItems":"center","justifyContent":"center"}} onClick={onClose} aria-label="Close">✕</button>
          </div>

          <div className="px-3">
            <div className="row g-3 align-items-end">
              <div className="col-md-3">
                <label className="form-label">DISTRICT NAME <span className="text-danger">*</span></label>
                <select style={{minWidth:"200px","padding":"8px 36px 8px 10px","borderRadius":"5px","border":"1px solid rgb(222, 222, 222)","fontSize":"13px","width":"100px","boxSizing":"border-box","transition":"0.2s ease-in-out","cursor":"pointer","color":"rgb(51, 51, 51)"}} value={district} onChange={e => setDistrict(e.target.value)}>
                  <option value="">All</option>
                  {districts.map(d => <option key={d} value={d}>{d}</option>)}
                </select>
              </div>
              <div className="col-md-5">
                <label className="form-label">SEARCH DOCTOR</label>

                <div style={{ position: "relative", width: "260px" }}>
                                <input
                                  type="text"
                                  placeholder="Search product name..."
                                  value={query}
                                  onChange={e => setQuery(e.target.value)}
                                  style={{
                                    width: "100%",
                                    padding: "8px 36px 8px 10px",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                    fontSize: "14px",
                                  }}
                                />
                                <FiSearch
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    color: "#555",
                                    fontSize: "18px",
                                  }}
                                />
                              </div>
              </div>
            </div>
          </div>

          <div className="px-3 mt-3">
            <div className="table-responsive app-table-wrap">
              <table className="table table-hover align-middle mb-0">
                <thead className="small text-muted">
                  <tr>
                    <th>DOCTOR'S NAME</th>
                    <th>SPECIALIZATION</th>
                    <th>MOBILE NO</th>
                    <th>HOSPITAL / ADDRESS</th>
                    <th>COMMISSION</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map(d => {
                    const isSelected = d.id === selectedId;
                    return (
                      <tr key={d.id}
                          className={isSelected ? "selected-row" : ""}
                          onClick={() => { console.log(d); setSelectedId(d.id); formik.setFieldValue("doctorName", d.doctorFullName); onClose();}}
                          >
                        <td>
                          <div className="fw-semibold">{d.doctorFullName}</div>
                          <div className="text-muted small">{d.stateName}</div>
                        </td>
                        <td>{d.specialization || "-"}</td>
                        <td>{d.mobileNo || "-"}</td>
                        <td>{d.hospitalName || d.address || "-"}</td>
                        <td>{d.commissionPercent ? `${d.commissionPercent}%` : "-"}</td>
                      
                      </tr>
                    );
                  })}
                  {data?.length === 0 && (
                    <tr><td colSpan={6} className="text-center text-muted py-4">No doctors found</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="modal-footer justify-content-between">
            <button className="btn btn-outline-secondary" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
      <div className="modal-backdrop show"></div>
    </div>
  );
}
